import { ArrowLeft, MapPin, Calendar, Users, Plane, Hotel, Utensils, Building2, Waves, Compass, Wind, Camera } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const DUBAI_HERO = 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c';
const DUBAI_IMAGES = {
  day1: 'https://images.pexels.com/photos/12099895/pexels-photo-12099895.jpeg',
  day2: 'https://images.pexels.com/photos/35665788/pexels-photo-35665788.jpeg',
  day3: 'https://images.pexels.com/photos/35972428/pexels-photo-35972428.jpeg',
  day4: 'https://images.pexels.com/photos/21856248/pexels-photo-21856248.jpeg',
};

export default function Dubai() {
  const navigate = useNavigate();

  const days = [
    { day: 1, title: 'Chegada: Primeiras Impressões de Luxo', description: 'Bem-vindo ao futuro - Dubai o recebe com estilo',
      highlights: [
        { icon: Plane, label: 'Transfer Privativo', detail: 'Recepção VIP no aeroporto e transfer para hotel exclusivo' },
        { icon: Hotel, label: 'Check-in Premium', detail: 'Acomodação em hotel selecionado na Dubai Marina ou Downtown' },
        { icon: Compass, label: 'Passeio Noturno', detail: 'Exploração da Marina com vista para os arranha-céus iluminados' },
        { icon: Utensils, label: 'Jantar na Marina', detail: 'Refeição em restaurante com vista espetacular' },
      ],
      highlight: 'Um dia planejado para sua recuperação da viagem, oferecendo as primeiras fotos inesquecíveis da metrópole do futuro.' },
    { day: 2, title: 'Ícones Mundiais: O Coração de Dubai', description: 'Visite os três símbolos que definem Dubai',
      highlights: [
        { icon: Building2, label: 'Burj Khalifa', detail: 'Subida ao mirante do edifício mais alto do mundo para vista de 360 graus' },
        { icon: Building2, label: 'Dubai Mall', detail: 'Exploração do maior shopping do planeta com lojas exclusivas' },
        { icon: Waves, label: 'Dubai Fountain', detail: 'Espetáculo das águas dançantes ao pôr do sol' },
        { icon: Camera, label: 'Fotografia Premium', detail: 'Capture os momentos mais icônicos de Dubai' },
      ],
      highlight: 'Três ícones mundiais que definem Dubai como destino de luxo e modernidade sem limites.' },
    { day: 3, title: 'Safari: A Alma do Deserto', description: 'Imersão na natureza selvagem do deserto árabe',
      highlights: [
        { icon: Wind, label: 'Dune Bashing 4x4', detail: 'Aventura emocionante pelas dunas douradas em veículos preparados' },
        { icon: Compass, label: 'Pôr do Sol no Deserto', detail: 'Momento mágico com vista panorâmica das dunas' },
        { icon: Utensils, label: 'Jantar Árabe', detail: 'Banquete tradicional em acampamento beduino' },
        { icon: Camera, label: 'Shows Culturais', detail: 'Apresentações tradicionais de dança e música árabe' },
      ],
      highlight: 'O ponto alto da viagem: uma conexão mágica entre a adrenalina e a tradição milenar árabe.' },
    { day: 4, title: 'Lifestyle & Luxo: Palm Jumeirah', description: 'Exclusividade pura na ilha artificial mais famosa do mundo',
      highlights: [
        { icon: Waves, label: 'Beach Clubs', detail: 'Dia em um dos beach clubs mais exclusivos com serviço impecável' },
        { icon: Building2, label: 'Atlantis Resort', detail: 'Visita ao icônico resort e exploração do parque Aquaventure' },
        { icon: Compass, label: 'Aventura no Mar', detail: 'Opcional - Passeio de Jet Ski ao redor da ilha' },
        { icon: Utensils, label: 'Almoço Premium', detail: 'Refeição gourmet com vista para a Marina' },
      ],
      highlight: 'Experiência de lifestyle premium na ilha artificial mais famosa do mundo, onde o luxo encontra a inovação.' },
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <div className="relative h-96 bg-cover bg-center flex items-center justify-center" style={{ backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.3) 100%), url('${DUBAI_HERO}')` }}>
        <div className="text-center text-white z-10">
          <h1 className="text-5xl md:text-6xl font-bold mb-4 text-white">ROTEIRO DUBAI</h1>
          <p className="text-xl md:text-2xl font-light">Onde o Futuro Encontra o Luxo</p>
        </div>
      </div>

      <div className="container py-6">
        <button onClick={() => navigate('/#destinations')} className="flex items-center gap-2 text-primary hover:text-accent transition-colors font-semibold">
          <ArrowLeft size={20} /> Voltar aos Destinos
        </button>
      </div>

      <section className="py-12 bg-slate-50">
        <div className="container">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              Uma jornada de 8 dias desenhada para explorar o melhor de Dubai: desde os ícones mundiais como o Burj Khalifa até a autêntica experiência do deserto árabe. Luxo, modernidade e tradição em perfeita harmonia.
            </p>
            <div className="grid grid-cols-3 gap-4 mt-8">
              <div className="flex flex-col items-center"><Calendar className="text-accent mb-2" size={32} /><p className="font-semibold text-primary">8 Dias</p></div>
              <div className="flex flex-col items-center"><Users className="text-accent mb-2" size={32} /><p className="font-semibold text-primary">A partir de 1 pessoa</p></div>
              <div className="flex flex-col items-center"><Plane className="text-accent mb-2" size={32} /><p className="font-semibold text-primary">Tudo Incluído</p></div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 flex-1">
        <div className="container">
          <h2 className="text-4xl font-bold text-center mb-16 text-primary">SEU CRONOGRAMA PREMIUM</h2>
          <div className="space-y-12">
            {days.map((dayInfo, index) => (
              <div key={dayInfo.day} className="fade-in-up" style={{ animationDelay: `${index * 80}ms` }}>
                <div className="grid md:grid-cols-2 gap-8 items-start">
                  <div>
                    <div className="inline-block px-4 py-2 bg-accent/10 border border-accent/30 rounded-full mb-4">
                      <p className="text-accent font-bold text-sm">DIA {dayInfo.day}</p>
                    </div>
                    <h3 className="text-3xl font-bold text-primary mb-2">{dayInfo.title}</h3>
                    <p className="text-muted-foreground text-lg mb-6">{dayInfo.description}</p>
                    <div className="space-y-4 mb-6">
                      {dayInfo.highlights.map((h, idx) => {
                        const Icon = h.icon;
                        return (
                          <div key={idx} className="flex gap-4">
                            <div className="flex-shrink-0"><Icon className="text-accent" size={24} /></div>
                            <div>
                              <p className="font-semibold text-primary">{h.label}</p>
                              <p className="text-muted-foreground text-sm">{h.detail}</p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="bg-accent/5 border-l-4 border-accent p-4 rounded">
                      <p className="text-primary font-semibold italic">“{dayInfo.highlight}”</p>
                    </div>
                  </div>
                  <div className="rounded-lg h-96 overflow-hidden shadow-lg">
                    <img src={DUBAI_IMAGES[`day${dayInfo.day}`]} alt={dayInfo.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
                  </div>
                </div>
                {index < days.length - 1 && <hr className="my-12 border-slate-200" />}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-slate-50">
        <div className="container">
          <h2 className="text-3xl font-bold text-center mb-12 text-primary">O QUE ESTÁ INCLUÍDO</h2>
          <div className="grid md:grid-cols-2 gap-8 max-w-3xl mx-auto">
            <div className="flex gap-4"><Hotel className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Hospedagem Premium</h3><p className="text-muted-foreground text-sm">Hotéis 5 estrelas na Dubai Marina ou Downtown</p></div></div>
            <div className="flex gap-4"><Plane className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Transferências Privadas</h3><p className="text-muted-foreground text-sm">Todos os transportes em veículos premium</p></div></div>
            <div className="flex gap-4"><Building2 className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Ingressos para Atrações</h3><p className="text-muted-foreground text-sm">Burj Khalifa, Dubai Mall, Aquaventure e mais</p></div></div>
            <div className="flex gap-4"><Utensils className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Refeições Gourmet</h3><p className="text-muted-foreground text-sm">Café da manhã, almoço e jantar em restaurantes premium</p></div></div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-primary text-white">
        <div className="container text-center">
          <h2 className="text-4xl font-bold mb-4 text-white">Pronto para Viver Esta Experiência?</h2>
          <p className="text-lg mb-8 text-white/90">Entre em contato conosco e customize seu roteiro</p>
          <a href="https://wa.me/5548991904829?text=Olá! Gostaria de orçar o roteiro premium de Dubai." target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-white text-primary font-bold rounded-full hover:bg-slate-100 transition-colors">
            Solicitar Orçamento via WhatsApp
          </a>
        </div>
      </section>

      <section className="py-8 bg-slate-50">
        <div className="container text-center text-muted-foreground text-sm">
          <p>PROPOSTA EXCLUSIVA | 2026</p>
          <p>@jmtravel.oficial | CNPJ 64.418.580/0001-14</p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
